import React from "react";
import "./GlobalBadge.css";

export default function GlobalBadge({
  active,
  activeText = "Active",
  inactiveText = "Inactive",
  className = ""
}) {
  return (
    <span
      className={`gbd-badge ${active ? "gbd-badge--on" : "gbd-badge--off"} ${className}`.trim()}
    >
      {active ? activeText : inactiveText}
    </span>
  );
}

